import { IPage, ITitlePage } from '../../interfaces';
import {
    setActivityLogForcedUpdateTime,
    setBalanceLogForcedUpdateTime,
    setCallDataRecordsForcedUpdateTime,
    setCallDataRecordsForcedUpdateTimeBeta,
    setCardSetsForcedUpdateTime,
    setCardsForcedUpdateTime,
    setCompaniesForcedUpdateTime,
    setCountriesForcedUpdateTime,
    setCurrenciesForcedUpdateTime,
    setMonthlyUsageForcedUpdateTime,
    setOperatorsForcedUpdateTime,
    setOrdersForcedUpdateTime,
    setPackagesUnitsLogsForcedUpdateTime,
    setPurchaseRatesForcedUpdateTime,
    setRatesForcedUpdateTime,
    setReportsForcedUpdateTime,
    setTariffsForcedUpdateTime,
    setTariffsPackagesToByForcedUpdateTime,
    setTariffsToBuyForcedUpdateTime,
    setUsersForcedUpdateTime,
    setZonesForcedUpdateTime,
} from '../../middleware';
import { setSubscribersForcedUpdateTime as setSubscribersForcedUpdateTimeV2 } from '../../middleware/subscribers';

export const ocsPages: IPage[] = [
    {
        id: '0000.02-Separator',
        componentName: 'Separator',
        url: '#',
        isActive: false,
        isMenu: true,
        isMenuSeparator: true,
        roleRight: ['ROOT'],
    },
    {
        id: '0000-MyMenu',
        componentName: 'My',
        title: 'MY_PROFILE_NAME',
        url: '#',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'SolutionOutlined',
        subMenu: [
            {
                id: '0002-Profile-List',
                componentName: 'MyProfileList',
                url: '#',
            },
            {
                id: '0002-Profile-view',
                componentName: 'Profile',
                title: 'Profile',
                url: '/profile',
                isActive: true,
                isDefault: false,
                isMenu: true,
                isNotImpersonating: true,
                menuIcon: 'UserOutlined',
            },
            {
                id: '0002-Profile-edit',
                componentName: 'ProfileEdit',
                title: 'Edit Profile',
                url: '/profile/edit',
                isActive: true,
                isDefault: false,
                isNotImpersonating: true,
                menuIcon: 'FormOutlined',
            },
            {
                id: '0002-MyCompany-List',
                componentName: 'MyCompanyList',
                url: '#',
            },
            {
                id: '0002-MyCompany-view',
                componentName: 'MyCompany',
                title: 'My Company',
                url: '/my_company',
                isActive: true,
                isDefault: false,
                isMenu: true,
                menuIcon: 'BankOutlined',
            },
            {
                id: '0002-MyCompany-edit',
                componentName: 'MyCompanyEdit',
                title: 'Edit My Company',
                url: '/my_company/edit',
                isActive: true,
                isDefault: false,
                menuIcon: 'FormOutlined',
                roleRight: ['ADMIN'],
            },
            {
                id: '0002-MyAlarms',
                componentName: 'MyAlarms',
                title: 'My Alarms',
                url: '/my_alarms',
                isActive: true,
                isDefault: false,
                isMenu: true,
                menuIcon: 'NotificationOutlined',
                roleRight: ['USER'],
            },
            {
                id: '002-Monthly-usage-list',
                componentName: 'MonthlyUsageList',
                title: 'Monthly Usage',
                url: '/monthly_usage',
                isActive: true,
                isDefault: false,
                isMenu: true,
                menuIcon: 'FileDoneOutlined',
                featureFlag: ['newChargingSystem'],
                forcedUpdate: setMonthlyUsageForcedUpdateTime,
            },
        ],
    },
    {
        id: '0000.99-Separator',
        componentName: 'Separator',
        url: '#',
        isActive: true,
        isMenu: true,
        isMenuSeparator: true,
    },
    {
        id: '0001-Dashboard-list',
        componentName: 'Dashboard',
        title: 'Dashboard',
        url: '/',
        isActive: true,
        isDefault: true,
        isMenu: true,
        menuIcon: 'DashboardOutlined',
    },
    {
        id: '0003-Users-list',
        componentName: 'UsersList',
        title: 'Users',
        url: '/users',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'TeamOutlined',
        roleRightDelete: ['ADMIN'],
        forcedUpdate: setUsersForcedUpdateTime,
    },
    {
        id: '0003-Users-new',
        componentName: 'UserNew',
        title: 'New User',
        url: '/users/new',
        isActive: true,
        isDefault: false,
        roleRight: ['ADMIN'],
        menuIcon: 'PlusSquareOutlined',
    },
    {
        id: '0003-Users-edit',
        componentName: 'UserEdit',
        title: 'Edit User',
        url: '/users/:id/edit',
        isActive: true,
        isDefault: false,
        roleRight: ['ADMIN'],
        menuIcon: 'FormOutlined',
    },
    {
        id: '0003-Users-view',
        componentName: 'User',
        title: 'User',
        url: '/users/:id',
        isActive: true,
        isDefault: false,
        menuIcon: 'EyeOutlined',
    },
    {
        id: '0004-Companies-list',
        componentName: 'CompaniesList',
        title: 'Companies',
        url: '/companies',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'BankOutlined',
        roleRightDelete: ['LORD'],
        forcedUpdate: setCompaniesForcedUpdateTime,
        companyTypeDenied: ['MNO'],
    },
    {
        id: '0004-Companies-hierarchy',
        componentName: 'CompaniesHierarchy',
        title: 'Companies by Hierarchy',
        url: '/companies/hierarchy',
        isActive: true,
        isDefault: false,
        companyTypeDenied: ['MNO'],
        menuIcon: 'PartitionOutlined',
    },
    {
        id: '0004-Companies-new',
        componentName: 'CompanyNew',
        title: 'New Company',
        url: '/companies/new',
        isActive: true,
        isDefault: false,
        roleRight: ['ADMIN'],
        companyTypeDenied: ['MNO'],
        menuIcon: 'PlusSquareOutlined',
    },
    {
        id: '0004-Companies-view',
        componentName: 'Company',
        title: 'Company',
        url: '/companies/:id',
        isActive: true,
        isDefault: false,
        companyTypeDenied: ['MNO'],
        menuIcon: 'EyeOutlined',
    },
    {
        id: '0004-Companies-edit',
        componentName: 'CompanyEdit',
        title: 'Edit Company',
        url: '/companies/:id/edit',
        isActive: true,
        isDefault: false,
        roleRight: ['ADMIN'],
        companyTypeDenied: ['MNO'],
        menuIcon: 'FormOutlined',
    },
    {
        id: '0004.9-Separator',
        componentName: 'Separator',
        url: '#',
        isActive: true,
        isMenu: true,
        isMenuSeparator: true,
    },
    {
        id: '0005-CardSets-list',
        componentName: 'CardSetsList',
        title: 'Card Sets',
        url: '/card_sets',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'GroupOutlined',
        forcedUpdate: setCardSetsForcedUpdateTime,
        companyTypeDenied: ['MNO'],
        roleRightDelete: ['USER'],
    },
    {
        id: '0005-CardSets-new',
        componentName: 'CardSetNew',
        title: 'New Card Set',
        url: '/card_sets/new',
        isActive: true,
        isDefault: false,
        companyTypeDenied: ['MNO'],
        menuIcon: 'PlusSquareOutlined',
        roleRight: ['USER'],
    },
    {
        id: '0005-CardSets-view',
        componentName: 'CardSet',
        title: 'Card Set',
        url: '/card_sets/:id',
        isActive: true,
        isDefault: false,
        companyTypeDenied: ['MNO'],
        menuIcon: 'EyeOutlined',
    },
    {
        id: '0005-CardSets-edit',
        componentName: 'CardSetEdit',
        title: 'Edit Card Set',
        url: '/card_sets/:id/edit',
        isActive: true,
        isDefault: false,
        companyTypeDenied: ['MNO'],
        menuIcon: 'FormOutlined',
        roleRight: ['USER'],
    },
    {
        id: '0006-Cards-list',
        componentName: 'CardList',
        title: 'Cards',
        url: '/cards',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'AppstoreOutlined',
        forcedUpdate: setCardsForcedUpdateTime,
    },
    {
        id: '0006-Cards-view',
        componentName: 'Card',
        title: 'Card',
        url: '/cards/:id',
        isActive: true,
        isDefault: false,
        menuIcon: 'EyeOutlined',
    },
    {
        id: '0006-Cards-edit',
        componentName: 'CardEdit',
        title: 'Edit Card',
        url: '/cards/:id/edit',
        isActive: true,
        isDefault: false,
        companyTypeDenied: ['MNO'],
        menuIcon: 'FormOutlined',
        roleRight: ['USER'],
    },
    {
        id: '0007-CallDataRecordsShow-list',
        componentName: 'CallDataRecordsList',
        title: 'Intermediate CDRs',
        url: '/intermediate_cdr',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'DatabaseOutlined',
        roleRight: ['LORD'],
        roleRightDelete: ['ROOOOT'],
        featureFlag: ['showIntermediateCdr'],
        forcedUpdate: setCallDataRecordsForcedUpdateTime,
    },
    // Beta
    {
        id: '0008-CallDataRecordsBeta-list',
        componentName: 'CallDataRecordsListBeta',
        title: 'Call Data Records',
        url: '/call_data_records',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'DatabaseOutlined',
        roleRightDelete: ['ROOOOT'],
        forcedUpdate: setCallDataRecordsForcedUpdateTimeBeta,
    },
    {
        id: '0008-BalanceLog-list',
        componentName: 'BalanceLogList',
        title: 'Balance log',
        url: '/balance_log',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'SwapOutlined',
        roleRightDelete: ['ROOOOT'],
        forcedUpdate: setBalanceLogForcedUpdateTime,
        companyTypeDenied: ['MNO'],
        roleRight: ['USER'],
    },
    {
        id: '0008.7-ActivityLog-list',
        componentName: 'ActivityLogList',
        title: 'Activity log',
        url: '/activity_log',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'SwapOutlined',
        roleRight: ['ROOT'],
        roleRightDelete: ['ROOOOT'],
        forcedUpdate: setActivityLogForcedUpdateTime,
        companyTypeDenied: ['MNO'],
    },
    {
        id: '0008.8-PackagesUnitsLogs-list',
        componentName: 'PackagesUnitsLogsList',
        title: 'Packages Units Logs',
        url: '/packages_units_logs',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'SwapOutlined',
        roleRight: ['ADMIN'],
        roleRightDelete: ['ROOOOT'],
        forcedUpdate: setPackagesUnitsLogsForcedUpdateTime,
        companyTypeRight: ['SKYMOND', 'RESELLER', 'SYSTEM INTEGRATOR', 'MVNO', 'END-USER'],
    },
    // {
    //     id: '0008.9-PaperTrailLogs-list',
    //     componentName: 'PaperTrailLogsList',
    //     title: 'Paper Trail Logs',
    //     url: '/paper_trail_logs',
    //     isActive: true,
    //     isDefault: false,
    //     isMenu: true,
    //     menuIcon: 'SwapOutlined',
    //     roleRight: ['LORD'],
    //     roleRightDelete: ['LORD'],
    //     forcedUpdate: setPaperTrailLogsForcedUpdateTime,
    // },
    {
        id: '0009-Finances-list',
        componentName: 'Finances',
        title: 'Finances',
        url: '/finances',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'FundViewOutlined',
    },
    {
        id: '0009.9-MyPackages',
        componentName: 'Packages',
        title: 'My Packages',
        url: '#',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'ShoppingOutlined',
        roleRight: ['ADMIN'],
        companyTypeRight: ['SKYMOND', 'RESELLER', 'SYSTEM INTEGRATOR', 'MVNO', 'END-USER'],
        subMenu: [
            {
                id: '0023-Packages-buy',
                componentName: 'PackagesBuy',
                title: 'Buy Packages',
                url: '/packages/buy',
                isActive: true,
                isDefault: false,
                isMenu: true,
                menuIcon: 'ImportOutlined',
                roleRight: ['ADMIN'],
                roleRightDelete: ['ADMIN'],
                companyTypeRight: ['SKYMOND', 'RESELLER', 'SYSTEM INTEGRATOR', 'MVNO', 'END-USER'],
            },
            {
                id: '0023-Packages-Instance-view',
                componentName: 'PackageInstance',
                title: 'Show Package Instance',
                url: '/packages-instance/:id',
                isActive: true,
                isDefault: false,
                roleRight: ['ADMIN'],
                companyTypeRight: ['SKYMOND', 'RESELLER', 'SYSTEM INTEGRATOR', 'MVNO', 'END-USER'],
                menuIcon: 'EyeOutlined',
            },
            {
                id: '0023-Packages-Instance-edit',
                componentName: 'PackageInstanceEdit',
                title: 'Edit Package',
                url: '/packages-instance/:id/edit',
                isActive: true,
                isDefault: false,
                roleRight: ['ADMIN'],
                companyTypeRight: ['SKYMOND', 'RESELLER', 'SYSTEM INTEGRATOR', 'MVNO', 'END-USER'],
                menuIcon: 'FormOutlined',
            },
            {
                id: '0023-Packages-sell',
                componentName: 'PackagesSell',
                title: 'Sell Packages',
                url: '/packages/sell',
                isActive: true,
                isDefault: false,
                isMenu: true,
                menuIcon: 'ExportOutlined',
                roleRight: ['ADMIN'],
                roleRightDelete: ['ADMIN'],
                companyTypeRight: ['SKYMOND', 'RESELLER', 'SYSTEM INTEGRATOR', 'MVNO'],
            },
            {
                id: '0023-Packages-new',
                componentName: 'PackageNew',
                title: 'New Package',
                url: '/packages/new',
                isActive: true,
                isDefault: false,
                roleRight: ['ADMIN'],
                companyTypeRight: ['SKYMOND', 'RESELLER', 'SYSTEM INTEGRATOR', 'MVNO'],
                menuIcon: 'PlusSquareOutlined',
            },
            {
                id: '0023-Packages-edit',
                componentName: 'PackageEdit',
                title: 'Edit Package',
                url: '/packages/:id/edit',
                isActive: true,
                isDefault: false,
                roleRight: ['ADMIN'],
                companyTypeRight: ['SKYMOND', 'RESELLER', 'SYSTEM INTEGRATOR', 'MVNO'],
                menuIcon: 'FormOutlined',
            },
            {
                id: '0023-Packages-view',
                componentName: 'PackageRoot',
                title: 'Show Package',
                url: '/packages/:id',
                isActive: true,
                isDefault: false,
                roleRight: ['ADMIN'],
                companyTypeRight: ['SKYMOND', 'RESELLER', 'SYSTEM INTEGRATOR', 'MVNO'],
                menuIcon: 'EyeOutlined',
            },
            {
                id: '0023-Package-Instance-Buy',
                componentName: 'PackageInstanceBuy',
                title: 'Buy Package',
                url: '/packages-instance/:id/buy',
                isActive: true,
                isDefault: false,
                companyTypeRight: ['SKYMOND', 'RESELLER', 'SYSTEM INTEGRATOR', 'MVNO', 'END-USER'],
                menuIcon: 'EuroOutlined',
                roleRight: ['USER'],
            },
            {
                id: '0023-Package-Instance-Buy-Preview',
                componentName: 'PackageInstanceBuyPreview',
                title: 'Package Preview',
                url: '/packages-instance/:id/preview',
                isActive: true,
                isDefault: false,
                companyTypeRight: ['SKYMOND', 'RESELLER', 'SYSTEM INTEGRATOR', 'MVNO', 'END-USER'],
                menuIcon: 'EyeOutlined',
            },
        ],
    },
    {
        id: '0009.9-Separator',
        componentName: 'Separator',
        url: '#',
        isActive: true,
        isMenu: true,
        isMenuSeparator: true,
        roleRight: ['ADMIN'],
    },
    {
        id: '0010.0-Geotracking',
        componentName: 'GeoTracking',
        title: 'Geo-tracking',
        url: '/geo-tracking',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'AimOutlined',
        roleRight: ['ADMIN'],
    },
    {
        id: '0013-Operators-list',
        componentName: 'OperatorsList',
        title: 'Operators',
        url: '/operators',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'PhoneOutlined',
        roleRight: ['LORD'],
        roleRightDelete: ['LORD'],
        forcedUpdate: setOperatorsForcedUpdateTime,
        companyTypeDenied: ['MNO'],
    },
    {
        id: '0013-Operators-new',
        componentName: 'OperatorNew',
        title: 'New Operator',
        url: '/operators/new',
        isActive: true,
        isDefault: false,
        roleRight: ['LORD'],
        companyTypeDenied: ['MNO'],
        menuIcon: 'PlusSquareOutlined',
    },
    {
        id: '0013-Operators-view',
        componentName: 'Operator',
        title: 'Operator',
        url: '/operators/:id',
        isActive: true,
        isDefault: false,
        roleRight: ['LORD'],
        companyTypeDenied: ['MNO'],
        menuIcon: 'EyeOutlined',
    },
    {
        id: '0013-Operators-edit',
        componentName: 'OperatorEdit',
        title: 'Edit Operator',
        url: '/operators/:id/edit',
        isActive: true,
        isDefault: false,
        roleRight: ['LORD'],
        companyTypeDenied: ['MNO'],
        menuIcon: 'FormOutlined',
    },
    {
        id: '0014-SalesRateLists-list',
        componentName: 'SalesRateLists',
        title: 'Rates',
        url: '/sales_rate_lists',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'WalletOutlined',
        roleRight: ['ADMIN'],
        roleRightDelete: ['ADMIN'],
        forcedUpdate: setRatesForcedUpdateTime,
        companyTypeDenied: ['MNO'],
    },
    {
        id: '0014-2-SalesRateLists-list',
        componentName: 'SalesRateListsV2',
        title: 'Rates V2' as ITitlePage, // ToDo: 21.07.2025 - need translate
        url: '/sales_rate_lists_v2',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'WalletOutlined',
        roleRight: ['LORD'],
        roleRightDelete: ['LORD'],
        forcedUpdate: setRatesForcedUpdateTime,
        companyTypeDenied: ['MNO'],
    },
    {
        id: '0014-SalesRateLists-new',
        componentName: 'SalesRateListNewV1',
        title: 'New Sales Rate List',
        url: '/sales_rate_lists/new',
        isActive: true,
        isDefault: false,
        roleRight: ['ADMIN'],
        companyTypeDenied: ['MNO'],
        menuIcon: 'PlusSquareOutlined',
    },
    {
        id: '0014-2-SalesRateLists-new',
        componentName: 'SalesRateListNewV2',
        title: 'New Sales Rate List V2' as ITitlePage, // ToDo: 21.07.2025 - need translate
        url: '/sales_rate_lists_v2/new',
        isActive: true,
        isDefault: false,
        roleRight: ['LORD'],
        companyTypeDenied: ['MNO'],
        menuIcon: 'PlusSquareOutlined',
    },
    {
        id: '0014-SalesRateLists-edit',
        componentName: 'SalesRateListEditV1',
        title: 'Edit Sales Rate List',
        url: '/sales_rate_lists/:id/edit',
        isActive: true,
        isDefault: false,
        roleRight: ['ADMIN'],
        companyTypeDenied: ['MNO'],
        menuIcon: 'FormOutlined',
    },
    {
        id: '0014-2-SalesRateLists-edit',
        componentName: 'SalesRateListEditV2',
        title: 'Edit Sales Rate List V2' as ITitlePage, // ToDo: 21.07.2025 - need translate
        url: '/sales_rate_lists_v2/:id/edit',
        isActive: true,
        isDefault: false,
        roleRight: ['LORD'],
        companyTypeDenied: ['MNO'],
        menuIcon: 'FormOutlined',
    },
    {
        id: '0014-SalesRateLists-view',
        componentName: 'SalesRateListV1',
        title: 'Sales Rate List',
        url: '/sales_rate_lists/:id',
        isActive: true,
        isDefault: false,
        roleRight: ['ADMIN'],
        companyTypeDenied: ['MNO'],
        menuIcon: 'EyeOutlined',
    },
    {
        id: '0014-2-SalesRateLists-view',
        componentName: 'SalesRateListV2',
        title: 'Sales Rate List V2' as ITitlePage, // ToDo: 21.07.2025 - need translate
        url: '/sales_rate_lists_v2/:id',
        isActive: true,
        isDefault: false,
        roleRight: ['LORD'],
        companyTypeDenied: ['MNO'],
        menuIcon: 'EyeOutlined',
    },
    {
        id: '0015-PurchaseRates-list',
        componentName: 'PurchaseRatesList',
        title: 'Purchase Rates',
        url: '/purchase_rate_lists',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'ShoppingCartOutlined',
        roleRight: ['LORD', 'ADMIN'],
        roleRightDelete: ['LORD'],
        companyTypeRight: ['SKYMOND', 'MNO'],
        forcedUpdate: setPurchaseRatesForcedUpdateTime,
    },
    {
        id: '0015-PurchaseRates-new',
        componentName: 'PurchaseRateListNew',
        title: 'New Purchase Rate List',
        url: '/purchase_rate_lists/new',
        isActive: true,
        isDefault: false,
        roleRight: ['LORD'],
        menuIcon: 'PlusSquareOutlined',
    },
    {
        id: '0015-PurchaseRates-edit',
        componentName: 'PurchaseRateListEdit',
        title: 'Edit Purchase Rate List',
        url: '/purchase_rate_lists/:id/edit',
        isActive: true,
        isDefault: false,
        roleRight: ['LORD'],
        menuIcon: 'FormOutlined',
    },
    {
        id: '0015-PurchaseRates-view',
        componentName: 'PurchaseRateList',
        title: 'Purchase Rate List',
        url: '/purchase_rate_lists/:id',
        isActive: true,
        isDefault: false,
        roleRight: ['LORD', 'ADMIN'],
        companyTypeRight: ['SKYMOND', 'MNO'],
        menuIcon: 'EyeOutlined',
    },
    {
        id: '0016-Orders-list',
        componentName: 'OrdersList',
        title: 'Orders',
        url: '/orders',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'AccountBookOutlined',
        roleRight: ['FINANCE'],
        roleRightDelete: ['ROOOOT'],
        forcedUpdate: setOrdersForcedUpdateTime,
        companyTypeDenied: ['MNO'],
    },
    {
        id: '0016-Orders-view',
        componentName: 'OrderView',
        title: 'Order',
        url: '/orders/:id',
        isActive: true,
        roleRight: ['FINANCE'],
        companyTypeDenied: ['MNO'],
        menuIcon: 'EyeOutlined',
    },
    {
        id: '0016-Orders-External',
        componentName: 'OrderExternal',
        title: 'External Order',
        url: '/order_external',
        isActive: true,
        roleRight: ['ADMIN'],
        companyTypeDenied: ['MNO'],
        menuIcon: 'ImportOutlined',
    },
    {
        id: '0016-Orders-NewOrder',
        componentName: 'OrderNew',
        title: 'New Order',
        url: '/company/:id/order/:by',
        isActive: true,
        roleRight: ['ADMIN'],
        companyTypeDenied: ['MNO'],
        menuIcon: 'CreditCardOutlined',
    },
    {
        id: '0015.9-Separator',
        componentName: 'Separator',
        url: '#',
        isActive: true,
        isMenu: true,
        isMenuSeparator: true,
    },
    {
        id: '0017-Zones-list',
        componentName: 'ZonesList',
        title: 'Zones',
        url: '/zones',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'GlobalOutlined',
        roleRight: ['LORD'],
        roleRightDelete: ['ROOOOT'],
        forcedUpdate: setZonesForcedUpdateTime,
        companyTypeDenied: ['MNO'],
    },
    {
        id: '0017-Zones-view',
        componentName: 'Zone',
        title: 'Zone',
        url: '/zones/:id',
        isActive: true,
        isDefault: false,
        roleRight: ['LORD'],
        companyTypeDenied: ['MNO'],
        menuIcon: 'EyeOutlined',
    },
    {
        id: '0018-Countries-list',
        componentName: 'CountryList',
        title: 'Countries',
        url: '/countries',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'EnvironmentOutlined',
        roleRight: ['LORD'],
        roleRightDelete: ['LORD'],
        forcedUpdate: setCountriesForcedUpdateTime,
        companyTypeDenied: ['MNO'],
    },
    {
        id: '0018-Countries-new',
        componentName: 'CountryNew',
        title: 'New Country',
        url: '/countries/new',
        isActive: true,
        isDefault: false,
        roleRight: ['LORD'],
        companyTypeDenied: ['MNO'],
        menuIcon: 'PlusSquareOutlined',
    },
    {
        id: '0018-Countries-edit',
        componentName: 'CountryEdit',
        title: 'Edit Country',
        url: '/countries/:id/edit',
        isActive: true,
        isDefault: false,
        roleRight: ['LORD'],
        companyTypeDenied: ['MNO'],
        menuIcon: 'FormOutlined',
    },
    {
        id: '0018-Countries-view',
        componentName: 'Country',
        title: 'Country',
        url: '/countries/:id',
        isActive: true,
        isDefault: false,
        roleRight: ['ADMIN'],
        companyTypeDenied: ['MNO'],
        menuIcon: 'EyeOutlined',
    },
    {
        id: '0019-Currencies-list',
        componentName: 'CurrenciesList',
        title: 'Currencies',
        url: '/currencies',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'EuroOutlined',
        roleRight: ['LORD'],
        roleRightDelete: ['ROOOOT'],
        forcedUpdate: setCurrenciesForcedUpdateTime,
        companyTypeDenied: ['MNO'],
    },
    {
        id: '0019-Currencies-view',
        componentName: 'Currency',
        title: 'Currency',
        url: '/currencies/:id',
        isActive: true,
        isDefault: false,
        roleRight: ['LORD'],
        companyTypeDenied: ['MNO'],
        menuIcon: 'EyeOutlined',
    },
    {
        id: '0019-Currencies-edit',
        componentName: 'CurrencyEdit',
        title: 'Edit Currency',
        url: '/currencies/:id/edit',
        isActive: true,
        isDefault: false,
        roleRight: ['LORD'],
        companyTypeDenied: ['MNO'],
        menuIcon: 'FormOutlined',
    },
    {
        id: '0020-Subscribers-list',
        componentName: 'SubscribersList',
        title: 'Subscribers',
        url: '/subscribers',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'LinkOutlined',
        roleRight: ['LORD', 'ADMIN'],
        roleRightDelete: ['ROOOOT'],
        companyTypeRight: ['SKYMOND', 'MNO'],
        forcedUpdate: setSubscribersForcedUpdateTimeV2,
    },
    {
        id: '0020-Subscribers-new',
        componentName: 'SubscriberNew',
        title: 'New Subscriber',
        url: '/subscribers/new',
        isActive: true,
        isDefault: false,
        roleRight: ['ROOOOT'],
        menuIcon: 'PlusSquareOutlined',
    },
    {
        id: '0020-Subscribers-edit',
        componentName: 'SubscriberEdit',
        title: 'Edit Subscribers',
        url: '/subscribers/:id/edit',
        isActive: true,
        isDefault: false,
        roleRight: ['ADMIN'],
        menuIcon: 'FormOutlined',
    },
    {
        id: '0020-Subscribers-view',
        componentName: 'Subscriber',
        title: 'Subscriber',
        url: '/subscribers/:id',
        isActive: true,
        isDefault: false,
        roleRight: ['ADMIN'],
        companyTypeRight: ['SKYMOND', 'MNO'],
        menuIcon: 'EyeOutlined',
    },
    {
        id: '0022-Reports-page',
        componentName: 'ReportsPageList',
        title: 'Reports',
        url: '/reports',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'FileDoneOutlined',
        roleRight: ['ADMIN'],
        roleRightDelete: ['ROOOOT'],
        forcedUpdate: setReportsForcedUpdateTime,
    },
    {
        id: '0022.9-Separator',
        componentName: 'Separator',
        url: '#',
        isActive: true,
        isMenu: true,
        isMenuSeparator: true,
        roleRight: ['ADMIN'],
    },
    {
        id: '0029.9-Tariffs',
        componentName: 'Tariff',
        title: 'Sell Tariffs',
        url: '#',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'ShoppingOutlined',
        featureFlag: ['createTariffs'],
        roleRight: ['USER'],
        subMenu: [
            {
                id: '0023-Tariffs-view',
                componentName: 'TariffsPage',
                title: 'Tariffs',
                url: '/tariffs',
                isActive: true,
                isMenu: true,
                menuIcon: 'MacCommandOutlined',
                featureFlag: ['createTariffs'],
                roleRight: ['USER'],
            },
            {
                id: '0024-Tariffs-view',
                componentName: 'TariffItem',
                title: 'Tariff',
                url: '/tariffs/:id',
                isActive: true,
                isDefault: false,
                featureFlag: ['createTariffs'],
                roleRight: ['USER'],
            },
            {
                id: '0025-Tariffs-Packages-view',
                componentName: 'TariffsPackages',
                title: 'Tariffs Packages',
                url: '/tariffs-packages',
                isActive: true,
                isMenu: true,
                menuIcon: 'MacCommandOutlined',
                featureFlag: ['createTariffs'],
                roleRight: ['USER'],
            },
            {
                id: '0026-Tariffs-Packages-view',
                componentName: 'TariffsPackagesItem',
                url: '/tariffs-packages/:id',
                isActive: true,
                isDefault: false,
                menuIcon: 'MacCommandOutlined',
                featureFlag: ['createTariffs'],
                roleRight: ['USER'],
            },
        ],
    },
    {
        id: '0030-Tariffs-Instance-Packages-view',
        componentName: 'TariffPackageInstancesList',
        title: 'Tariffs Packages Instances',
        url: '/tariffs-instance-packages',
        isActive: true,
        isMenu: true,
        menuIcon: 'MacCommandOutlined',
        featureFlag: ['createTariffs'],
        forcedUpdate: setTariffsForcedUpdateTime,
        roleRight: ['USER'],
    },
    {
        id: '0031-Tariffs',
        componentName: 'TariffBuy',
        title: 'Buy Tariffs',
        url: '#',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'ShoppingOutlined',
        featureFlag: ['createTariffs'],
        tariffsToBuyPresent: true,
        tariffPackagesToBuyPresent: true,
        roleRight: ['USER'],
        subMenu: [
            {
                id: '0028-Tariffs-To-Buy-view',
                componentName: 'TariffToBuyList',
                title: 'Tariffs to Buy' as ITitlePage,
                url: '/tariffs-to-buy',
                isActive: true,
                isMenu: true,
                menuIcon: 'MacCommandOutlined',
                featureFlag: ['createTariffs'],
                forcedUpdate: setTariffsToBuyForcedUpdateTime,
                tariffsToBuyPresent: true,
                roleRight: ['USER'],
            },
            {
                id: '0028-Tariffs-To-Buy-item',
                componentName: 'TariffToBuyItem',
                title: 'Tariff to Buy' as ITitlePage,
                url: '/tariffs-to-buy/:id',
                isActive: true,
                isMenu: false,
                featureFlag: ['createTariffs'],
                tariffsToBuyPresent: true,
                roleRight: ['USER'],
            },
            {
                id: '0029-Tariffs-To-Buy-view',
                componentName: 'TariffPackagesToBuyList',
                title: 'Tariffs Packages to Buy' as ITitlePage,
                url: '/tariffs-packages-to-buy',
                isActive: true,
                isMenu: true,
                menuIcon: 'MacCommandOutlined',
                featureFlag: ['createTariffs'],
                forcedUpdate: setTariffsPackagesToByForcedUpdateTime,
                tariffPackagesToBuyPresent: true,
                roleRight: ['USER'],
            },
            {
                id: '0029-Tariffs-To-Buy-item',
                componentName: 'TariffPackagesToBuyItem',
                title: 'Tariff Packages to buy' as ITitlePage,
                url: '/tariffs-packages-to-buy/:id',
                isActive: true,
                isMenu: false,
                featureFlag: ['createTariffs'],
                tariffPackagesToBuyPresent: true,
                roleRight: ['USER'],
            },
        ],
    },
    {
        id: '0099-About-page',
        componentName: 'About',
        title: 'About',
        url: '/about',
        isActive: true,
        isDefault: false,
        isMenu: true,
        menuIcon: 'InfoCircleOutlined',
    },
];
